import { ArchiveSortOption } from '../types'
import ArchiveCard from './ArchiveCard'
import { FC } from 'react'
import type { ArchivePuzzle } from './ArchivePage'

type Props = {
	sortOption: ArchiveSortOption
	puzzles: ArchivePuzzle[]
}

const ArchiveList: FC<Props> = ({ sortOption, puzzles }) => {
	switch (sortOption) {
		case 'stars-desc':
			puzzles.sort((a, b) => {
				if (a.score === b.score) {
					// puzzle number asc
					return a.puzzleNumber - b.puzzleNumber
				}
				return b.score - a.score
			})
			break
		case 'stars-asc':
			puzzles.sort((a, b) => {
				if (a.score === b.score) {
					// puzzle number asc
					return a.puzzleNumber - b.puzzleNumber
				}
				return a.score - b.score
			})
			break

		case 'number-desc':
			puzzles.sort((a, b) => b.puzzleNumber - a.puzzleNumber)
			break

		case 'number-asc':
		default:
			break
	}

	return (
		<div className="archive-list">
			{puzzles.map((puzzle, _) => {
				return (
					<ArchiveCard
						key={puzzle.puzzleNumber}
						score={puzzle.score}
						puzzleNumber={puzzle.puzzleNumber}
						time={puzzle.time}
						puzzleDate={puzzle.puzzleDate}
					/>
				)
			})}
		</div>
	)
}

export default ArchiveList
